<mat-toolbar color="primary">
  <span id="kopier-sak-dialog-tittel">
    @if (sak().erPause) {
      {{ "Kopier {navn}"|translate: {navn: sak().tittel} }}
    } @else {
      {{ "Kopier sak {nummer} {navn}"|translate: {nummer: sak().nummer, navn: sak().tittel} }}
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@switch (modus()) {
  @case ('skjema') {
    <form [formGroup]="skjema" (ngSubmit)="kopier()">
      <mat-dialog-content>
        @if (harFeil()) {
          <inline-melding type="feil">
            <p>{{ 'Sak kunne ikke kopieres til følgende møter:' | translate }}</p>
            <ul>
              @for (feil of feiLPerMoete; track feil.moete.id) {
                <li>
                  <span>{{ '{tittel} {nummer}, {dato} - {gruppe} i {organisasjon}' | translate: {tittel: feil.moete.tittel, nummer: feil.moete.nummer, dato: feil.moete.dato.start|zoneddatetime, gruppe: feil.gruppe.tittel, organisasjon: feil.gruppe.organisasjonsnavn} }}: </span>
                  <span class="valideringsfeil">{{ feil.valideringsfeil }}</span>
                </li>
              }
            </ul>
          </inline-melding>
        }

        <p class="info">
          @if (sak().erPause) {
            {{ 'Kopier {tittel} i {gruppetittel} i {organisasjon} med' | translate: {tittel: sak().tittel, gruppetittel: gruppe().tittel, organisasjon: gruppe().organisasjonsnavn} }}
          } @else {
            {{ 'Kopier sak {nummer} {tittel} i {gruppetittel} i {organisasjon} med' | translate: {nummer: sak().nummer, tittel: sak().tittel, gruppetittel: gruppe().tittel, organisasjon: gruppe().organisasjonsnavn} }}
            <span class="tellere">{{ '{antbeslutninger} beslutninger og {antdokumenter} saksdokumenter' | translate: {antbeslutninger: sak().beslutninger.length, antdokumenter: sak().dokumenter.length} }}</span>
          }
          {{ 'til følgende møter'|translate }}
        </p>

        <fieldset>
          <mat-form-field class="møtevelger">
            <mat-label>{{ "Velg møter du vil kopiere saken til" | translate }}</mat-label>
            <!-- tom placeholder da vi ikke ønsker å bruker velg-moeter sin std placeholder -->
            <velg-moeter [skjemakontroll]="skjema.controls.moeter" [ekspandertGruppe]="sak().eiendeGruppeId" placeholder=""/>
          </mat-form-field>
        </fieldset>

        @if (!sak().erPause) {
          <tips>
            <p>
              {{'Saksnavn, saksbeskrivelse, beslutningsforslag, dokumenter, samt referattekst og referatførte beslutninger blir kopiert.'|translate}}<br>
              {{'Tilgangsbegrensninger, oppgaver og kommentarer blir ikke kopiert.'|translate}}<br>
              {{'Temaer og sakstyper som ikke eksisterer i mottakende grupper blir opprettet automatisk.'|translate}}<br>
            </p>
            <p>{{ 'Saken blir lagt til som siste sak i det valgte møtet.'| translate }}</p>
          </tips>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <div>
          <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
          <submit-button [arbeidPaagaar]="lagrer()" [skjema]="skjema" spinnerTekst="{{'Kopierer...'|translate}}">
            {{ 'Kopier sak til {antall} møter'|translate:{antall: skjema.value.moeter!.length} }}
          </submit-button>
        </div>
      </mat-dialog-actions>
    </form>
  }
  @case ('kvittering') {
    <mat-dialog-content class="kvittering" data-testid="kopier-sak-dialog-kvittering">
      <p>
        {{ '{antall} sak(er) opprettet' | translate: {antall: kopiertTilMoeter().length} }}:
      </p>
      <ul>
        @for (moete of kopiertTilMoeter(); track moete.moete.id) {
          <li>
            <a (click)="gaaTilSak(moete.sak)">
              @if (sak().erPause) {
                {{ '{sakstittel} i {tittel} {nummer}, {dato} - {gruppetittel} i {organisasjon}'|translate: {sakstittel: moete.sak.tittel, tittel: moete.moete.tittel, nummer: moete.moete.nummer, dato: moete.moete.dato.start|zoneddatetime, gruppetittel: moete.gruppe.tittel, organisasjon: moete.gruppe.organisasjonsnavn} }}
              } @else {
                {{ 'Sak {saksnummer} i {tittel} {nummer}, {dato} - {gruppetittel} i {organisasjon}'|translate: {saksnummer: moete.sak.nummer, tittel: moete.moete.tittel, nummer: moete.moete.nummer, dato: moete.moete.dato.start|zoneddatetime, gruppetittel: moete.gruppe.tittel, organisasjon: moete.gruppe.organisasjonsnavn} }}
              }
            </a>
          </li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
          {{ 'Lukk'|translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
}
